import React from 'react'
import { Redirect } from 'react-router-dom'

import DashBoardRoutes from '../DashBoard/DashboardRoute';
import DashBoardAdminRoutes from '../Admin/DashboardAdminRoute';
import ProductRoute from '../Product/ProductRoute';
import OrdersRoute from '../Orders/OrdersRoute';
import DeliveryRoute from '../Delivery/DeliveryRoute';
import ChatRoute from '../Chat/ChatRoute';
import MarketingRoute from '../Marketing/MarketingRoute';
import LeadsRoute from '../Leads/LeadsRoute';
import TicketsRoute from '../Tickets/TicketsRoute';
import ContentsRoute from '../Contents/ContentsRoute';
import LogRoute from '../Log/LogRoute';
import SettingRoute from '../Settings/SettingRoute';
import HelpsRoute from '../Helps/HelpsRoute';
import { AuthRoles } from '../../Component/Auth/AuthRoles';

export const userList = {
    isAuthenticated: true,
    email: "abu@gmail.com",
    role: ["SA", 'ADMIN', "EDITOR"],
    id: "1"
}

// if (userList) {
//     console.log('ok');
// }

const redirectRoute = [
    {
        path: '/',
        exact: true,
        component: () => <Redirect to="/dashboard" />,
        auth: AuthRoles.admin,
    },
]

const errorRoute = [
    {
        component: () => <Redirect to="/session/404" />,
    },
]

const rootRouting = [
    ...DashBoardRoutes,
    ...DashBoardAdminRoutes,
    ...ProductRoute,
    ...OrdersRoute,
    ...DeliveryRoute,
    ...ChatRoute,
    ...MarketingRoute,
    ...LeadsRoute,
    ...TicketsRoute,
    ...ContentsRoute,
    ...LogRoute,
    ...SettingRoute,
    ...HelpsRoute,

    ...redirectRoute,
    ...errorRoute,
]

export default rootRouting
